import React from "react";
import { Select } from "antd/lib";
import { Option } from "antd/lib/mentions";

export const MobileDropdown = ({ seminars, setActiveSeminar }) => {
  const handleChange = (value) => {
    setActiveSeminar(value);
  };

  return (
    <Select
      onChange={handleChange}
      defaultValue={seminars[0]?.name}
      placeholder={seminars[0]?.name}
    >
      {seminars.map((_proj) => (
        <Option value={_proj._id}>{_proj.name}</Option>
      ))}
    </Select>
  );
};
